/** Blood Hub — AJA Abhaya Hastham Foundation blood donation app. */
export const bloodHub = {
  name: "Blood Hub",
  tagline: "Your trusted blood donation network",
  description:
    "Find donors by blood group and location, create emergency requests, and register as a voluntary donor — all from your phone.",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.ajacs.blooddonation",
  downloadLabel: "Download on Google Play",
  programSlug: "blood-donation",
} as const;
